declare let THREE: any;

export class ArrowHolder extends (THREE.Mesh as {
  new (geometry, material): any;
}) {
  static readonly Name = "ArrowHolder";
  Position: any;

  constructor(arrowName?) {
    const shape = new THREE.Shape();
    shape.moveTo(17, 17);
    shape.lineTo(9, 3);
    shape.lineTo(3, 9);
    shape.lineTo(17, 17);
    const geometry = new THREE.ShapeGeometry(shape);

    const material = new THREE.MeshBasicMaterial({
      color: 0x000000,
      side: THREE.DoubleSide
    });
    super(geometry, material);
    this.rotation.x = Math.PI / 2;
    this.position.y = 100;

    // const geometry = new THREE.SphereBufferGeometry(5, 32, 32);
    // const material = new THREE.MeshBasicMaterial({color: 0x000000});
    // super(geometry, material);
    this.name = arrowName ? arrowName : ArrowHolder.Name;
  }

  update(startPoint, endPoint) {
    this.position.set(endPoint.x, endPoint.y, endPoint.z);
    this.position.y = 0;
    const offset = startPoint
      .clone()
      .add(endPoint.clone().negate())
      .setLength(17 / Math.cos(Math.PI / 4));
    this.Position = this.position.clone();
    this.position.add(offset);

    this.rotation.z =
      Math.atan2(startPoint.z - endPoint.z, startPoint.x - endPoint.x) +
      Math.PI -
      Math.PI / 4;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Dimensions/ArrowHolder.ts